import React, { useContext, useEffect, useState } from "react";
import ColorsMain from "../../colors/ColorsMain";
import Logo from "../../assets/logos/LogoColurs.png";
import Banner from '../../assets/logos/banner2.png'

import { useNavigate } from 'react-router-dom';

import AcountSuccessful from '../../components/layouts/registro/AcountSuccessful';
import RegistreCompany from '../../components/layouts/registro/RegistreCompany';
import RegistrePerson from '../../components/layouts/registro/RegistrePerson';
import TypeUser from '../../components/layouts/registro/TypeUser';





import '../../css/login/login.css';
import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import { AuthContext } from "../../context/AuthContext"; // Asegúrate de importar el contexto correcto

import axios from 'axios';

export const Registro = () => {
    const navigate = useNavigate();
    const { isAuth, setAuthToken } = useContext(AuthContext); // Usa el contexto de Auth

    const [Layout, setLayout] = useState(1)
    const [listCountry, setListCountry] = useState([])
    const [TypePerson, setTypePerson] = useState(null)

    const [email, setEmail] = useState("")
    const [country, setCountry] = useState("")
    const [password, setPassword] = useState("")
    const [phone, setPhone] = useState("")
    const [phoneCode, setPhoneCode] = useState("+57")
    const [selectOnboarding, setSelectOnboarding] = useState('')
    const [firstName, setFirstName] = useState("")
    const [last_name, setLastName] = useState("")

    const [errorFirtsName, setErrorFirstName] = useState(false)
    const [errorLastName, setErrorLastName] = useState(false)
    const [errorContry, setErrorContry] = useState(false)
    const [ErrorContryFilter, setErrorContryFilter] = useState(false)

    const [errorEmail, setErrorEmail] = useState(false)
    const [errorPrefijo, setErrorPrefijo] = useState(false)
    const [ErrorCodePhone, setErrorCodePhone] = useState(false)

    const [errorPhone, setErrorPhone] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)


    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;


    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [errorMesagge, setErrorMesagge] = useState(false)

    useEffect(() => {
        setLayout(prevLayout => {
            if (TypePerson === 1 && prevLayout !== 2) return 2;
            if (TypePerson === 2 && prevLayout !== 3) return 3;
            return prevLayout;
        });
    }, [TypePerson]);

    useEffect(() => {
        if (firstName) {
            setErrorFirstName(false);
        }
        if (last_name) {
            setErrorLastName(false);
        }
        if (country) {
            setErrorContry(false);
        }
        if (email) {
            setErrorEmail(false);
        }
        if (phoneCode) {
            setErrorPrefijo(false);
        }
        if (phone && phone.length >= 10) {
            setErrorPhone(false);
            setErrorMesagge('');
        }
        if (password && password.length >= 8) {
            setErrorPassword(false);
            setErrorMesagge('');
        }
    }, [firstName, last_name, country, email, phoneCode, phone, password]);


    const ReturnRegister = () => {
        setError(false)
        setLayout(1)
        setTypePerson(null)
        setErrorFirstName(false)
        setErrorLastName(false)
        setErrorContry(false)
        setErrorPrefijo(false)
        setErrorPhone(false)
        setErrorPassword(false)
        setErrorMesagge(false)
        setErrorEmail(false)
        setPhone('')
    }
    const ReturnLogin = () => {
        setError(false)
        setLayout(1)
        setTypePerson(null)
        navigate("/login")
    }
    useEffect(() => {
        console.log();

        if (listCountry.length === 0) {

            ListCountrys()
        }
    }, [])


    const ListCountrys = async () => {

        await axios
            .post(`/api/country`, {})
            .then((response) => {
                setListCountry(response.data.data)
            })
            .catch((error) => {

            });
    }


    const validateFields = () => {
        let isValid = true;

        // Validar cada campo y actualizar el estado de error correspondiente
        if (!firstName) {
            setErrorFirstName(true);
            isValid = false;
        } else {
            setErrorFirstName(false);
        }

        if (!last_name) {
            setErrorLastName(true);
            isValid = false;
        } else {
            setErrorLastName(false);
        }

        if (!country) {
            setErrorContry(true);
            isValid = false;
        } else {
            setErrorContry(false);
        }

        if (!email) {
            setErrorEmail(true);
            isValid = false;
        } else {
            setErrorEmail(false);
        }

        if (!phoneCode) {
            setErrorCodePhone(true);
            isValid = false;
        } else {
            setErrorCodePhone(false);
        }

        // Solo validar selectOnboarding si es registro de empresa (TypePerson === 2)
        if (TypePerson === 2 && !selectOnboarding) {
            setErrorContryFilter(false);
        } else {
            setErrorContryFilter(false);
        }

        if (!phone || phone.length < 8 || phone.length > 11) {
            setErrorPhone(true);
            setErrorMesagge(t.register_validation.validation_phone)
            isValid = false;
        } else {
            setErrorPhone(false);
        }

        if (!password || password.length < 8) {
            setErrorPassword(true);
            setErrorMesagge(t.register_validation.validation_password)
            isValid = false;
        } else {
            setErrorPassword(false);
        }

        return isValid;
    };

    const RegisterPersonFetch = async () => {
        if (!validateFields()) {
            setError(true);
            return;
        }

        setLoading(true);
        let data = {
            "username": email,
            "first_name": firstName,
            "last_name": last_name,
            "country_code": phoneCode,
            "country": country,
            "email": email,
            "password": password,
            "type_person": TypePerson,
            "phone": phone.toString().replace(/\D/g, ""),
            "platform": "PANEL"
        };

        try {
            const response = await axios.post(`/api/registro`, { data });

            if (response.data.status === 201) {
                setLayout(4);
            } else {
                if (response.data.data.error === "Ya hay un usuario registrado con este número de celular") {
                    setErrorMesagge(`${t.registre_company.error_phone}: ${phone}`);
                    setError(true);
                } else if (response.data.data.error === "Ya hay un usuario registrado con este usuario") {
                    setErrorMesagge(t.register_validation.validation_existing_user);
                    setError(true);
                } else {
                    setError(true);
                    setErrorMesagge(t.register_validation.validation_unexpected);
                }
            }
        } catch (error) {
            if (error.response?.data?.data?.error === "Ya hay un usuario registrado con este número de celular") {
                setErrorMesagge(`${t.registre_company.error_phone}: ${phone}`);
                setError(true);
            } else if (error.response?.data?.error === "Ya hay un usuario registrado con este usuario") {
                setErrorMesagge(t.register_validation.validation_existing_user);
                setError(true);
            } else {
                setError(true);
                setErrorMesagge(t.register_validation.validation_unexpected);
            }
        } finally {
            setLoading(false);
        }
    };




    const RegisterCompanyFetch = async () => {

        if (!validateFields()) {
            setError(true);
            return;
        }

        setLoading(true)
        let data = {}
        data = {
            "username": email,
            "first_name": firstName,
            "last_name": last_name,
            "country_code": phoneCode,
            "country": country,
            "email": email,
            "password": password,
            "type_person": TypePerson,
            "phone": phone.toString().replace(/\D/g, ""),
            "country_company_incorporation": country === "CO" ? "CO" : "US",
            "platform": "PANEL",


        }
        await axios
            .post(`/api/registro`, { data })
            .then((response) => {
                if (response.data.status === 201) {
                    setLayout(4)
                } else if (response.data.data.status !== 201) {
                    console.log("ajajkdjdsjnjkansjnasdjnadsjnadsnj");

                    if (response.data.data.error === "Ya hay un usuario registrado con este número de celular") {

                        setErrorMesagge(`${t.registre_company.error_phone}: ${phone}`)
                        setError(true);
                    }
                    else if (response.data.data.error === 'Ya hay un usuario registrado con este número de celular') {
                        console.log('ESTOY DENTRO');
                        setError(true);
                        setErrorMesagge(`${t.registre_company.error_phone}: ${phone}`)
                    } else if (response.data.data.error === "Ya hay un usuario registrado con este usuario") {
                        setErrorMesagge(true)
                        setErrorMesagge(t.register_validation.validation_existing_user);
                    }
                    else {
                        setError(false)
                        console.log(response.data.data.error, 'ESTO ES LO QUE RESPONDE EL SERVICIO');
                        setErrorMesagge("Ocurrió un error al registrar la cuenta. Inténtelo de nuevo.");
                    }
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error, 'ESTO ES LO QUE LE MANDA en el error ');
                if (error.response.data.data.error === "Ya hay un usuario registrado con este número de celular") {

                    setErrorMesagge(`${t.registre_company.error_phone}: ${phone}`)
                    setError(true);
                }
                if (error.response && error.response.data.error === "Ya hay un usuario registrado con este usuario") {
                    setErrorMesagge(true)
                    setError(t.register_validation.validation_existing_user);
                } else {
                    setError(false)
                    console.log(error, 'ESTO ES LO QUE LE MANDA en el error ');
                    setErrorMesagge("Ocurrió un error al registrar la cuenta. Inténtelo de nuevo. 123");
                }
                setLoading(false);
            });
        setLoading(false)
        setError(false)

    }


    useEffect(() => {
        if (isAuth) {
            navigate("/splash"); // Redirige al dashboard si el usuario ya está autenticado
        }
    }, [isAuth, navigate]);
    const LoginRequest = async () => {
        setLoading(true)
        const data = {
            username: email,
            password: password,
        };
        await axios
            .post(`/api/login`, { data })
            .then((response) => {
                if (response.data.status === 200) {
                    setAuthToken(response.data.data.access);
                    localStorage.setItem("refreshToken", response.data.data.refresh);
                    localStorage.setItem("expiresAtC", new Date().toString());

                }
            })
            .catch((error) => {

            });
        setLoading(false)
        setError(false)
    };


    return (
        <div className="flex bg-black w-full min-h-screen">
            <div
                className="hidden md:flex w-3/5 h-screen relative"
                style={{
                    backgroundImage: `url(${Banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <p
                    className="
                    text-white 
                    w-[77%] 
                    text-[1.5rem]
                    md:text-[2rem]
                    md:leading-[3rem]
                    lg:text-[2.5rem]  
                    lg:leading-[4rem]
                    xl:leading-[4.5rem]
                    xl:text-[3.5rem]
                    2xl:text-[4.5rem]
                    2xl:leading-[5rem]
                    "
                    style={{
                        fontFamily: "brico",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    {GLOBAL_LANGUAGE[language].banner_login.p1}<br />
                    <span className="text-[#c5c5d3]">
                        {GLOBAL_LANGUAGE[language].banner_login.p2}<br />
                        {GLOBAL_LANGUAGE[language].banner_login.p3}
                    </span>
                </p>
            </div>
            <div className="flex w-full md:w-2/5 min-h-screen items-center justify-between flex-col p-4 md:p-8" style={{ background: ColorsMain.bgMain }}>
                <div></div>
                <div className="w-full md:w-[75%]">
                    <img src={Logo} style={{ width: 32, height: 32 }} alt="logo colurs" />
                </div>
                {Layout === 1 && <TypeUser onPress={setTypePerson} />}

                {Layout === 2 && <RegistrePerson
                    errorFirtsName={errorFirtsName}
                    errorLastName={errorLastName}
                    errorContry={errorContry}
                    ErrorContryFilter={ErrorContryFilter}
                    errorEmail={errorEmail}
                    errorPrefijo={errorPrefijo}
                    errorPhone={errorPhone}
                    errorPassword={errorPassword}
                    errorMesagge={errorMesagge}
                    loading={loading}
                    RegisterPersonFetch={RegisterPersonFetch}
                    setPhoneCode={setPhoneCode}
                    setLastName={setLastName}
                    setFirstName={setFirstName}
                    setPhone={setPhone}
                    setPassword={setPassword}
                    setEmail={setEmail}
                    setSelectOpcion={setCountry}
                    listCountry={listCountry}
                    onPressReturn={ReturnRegister}
                    onPressReturnLogin={ReturnLogin}
                    setError={error}
                    email={email}
                    country={country}
                    password={password}
                    phone={phone}
                    phoneCode={phoneCode}
                    firstName={firstName}
                    last_name={last_name}
                    error={error}
                />}

                {Layout === 3 && <RegistreCompany
                    ErrorContryFilter={ErrorContryFilter}
                    ErrorCodePhone={ErrorCodePhone}
                    errorFirtsName={errorFirtsName}
                    errorLastName={errorLastName}
                    errorContry={errorContry}
                    errorEmail={errorEmail}
                    errorPrefijo={errorPrefijo}
                    errorPhone={errorPhone}
                    errorPassword={errorPassword}
                    errorMesagge={errorMesagge}
                    loading={loading}
                    phone={phone}
                    RegisterCompanyFetch={RegisterCompanyFetch}
                    setCountry={setCountry}
                    setSelectOnboarding={setSelectOnboarding}
                    listCountry={listCountry}
                    onPressReturn={ReturnRegister}
                    onPressReturnLogin={ReturnLogin}
                    setPhoneCode={setPhoneCode}
                    setLastName={setLastName}
                    setFirstName={setFirstName}
                    setPhone={setPhone}
                    setPassword={setPassword}
                    setEmail={setEmail}
                />}

                {Layout === 4 && <AcountSuccessful loading={loading} ReturnLogin={ReturnLogin} LoginRequest={LoginRequest} correo={email} />}

                <div></div>
                <div></div>
            </div>
        </div>
    );
}

export default Registro;